import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const QuickActionToolbar = ({ actions }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  const defaultQuickActions = [
    { label: 'New Invoice', icon: 'FileText', action: () => navigate('/invoices'), color: 'primary' },
    { label: 'Record Expense', icon: 'Receipt', action: () => navigate('/expenses'), color: 'secondary' },
    { label: 'Add Account', icon: 'ListTree', action: () => navigate('/chart-of-accounts'), color: 'accent' },
    { label: 'Reconcile Bank', action: () => navigate('/bank-reconciliation'), icon: 'Landmark', color: 'success' }
  ];

  // Use provided actions or fall back to default
  const quickActions = actions?.length > 0 ? actions?.map(action => ({
    label: action?.label,
    icon: action?.icon,
    action: action?.onClick,
    color: action?.variant === 'default' ? 'primary' : action?.variant === 'outline' ? 'accent' : 'secondary'
  })) : defaultQuickActions;

  const handleActionClick = (action) => {
    action();
    setIsExpanded(false);
  };

  return (
    <>
      <div className="hidden lg:flex fixed bottom-8 right-8 gap-3 z-1030">
        {quickActions?.map((action, index) => (
          <Button
            key={index}
            variant={action?.color === 'primary' ? 'default' : action?.color === 'secondary' ? 'secondary' : action?.color === 'accent' ? 'outline' : 'success'}
            onClick={action?.action}
            iconName={action?.icon}
            iconPosition="left"
            className="shadow-lg hover-lift active-press"
          >
            {action?.label}
          </Button>
        ))}
      </div>
      <div className="lg:hidden fixed bottom-6 right-6 z-1030">
        {isExpanded && (
          <div className="absolute bottom-16 right-0 flex flex-col gap-3 mb-3">
            {quickActions?.map((action, index) => (
              <button
                key={index}
                onClick={() => handleActionClick(action?.action)}
                className="flex items-center gap-3 bg-card text-foreground px-4 py-3 rounded-lg shadow-lg hover-lift active-press transition-smooth"
              >
                <div className={`
                  w-10 h-10 rounded-md flex items-center justify-center
                  ${action?.color === 'primary' ? 'bg-primary/10' : ''}
                  ${action?.color === 'secondary' ? 'bg-secondary/10' : ''}
                  ${action?.color === 'accent' ? 'bg-accent/10' : ''}
                  ${action?.color === 'success' ? 'bg-success/10' : ''}
                `}>
                  <Icon
                    name={action?.icon}
                    size={20}
                    color={`var(--color-${action?.color})`}
                  />
                </div>
                <span className="font-body font-medium text-sm whitespace-nowrap">{action?.label}</span>
              </button>
            ))}
          </div>
        )}

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-14 h-14 bg-primary text-primary-foreground rounded-full shadow-xl flex items-center justify-center hover-lift active-press transition-smooth"
          aria-label="Quick actions"
        >
          <Icon name={isExpanded ? 'X' : 'Plus'} size={24} />
        </button>
      </div>
    </>
  );
};

export default QuickActionToolbar;